<template>
  <div class="pd-notice-modal-root">
    <div
      v-if="open"
      class="pd-notice-modal"
      role="dialog"
      aria-modal="true"
      :aria-label="$t('pdNoticeTitle')"
    >
      <div
        class="pd-notice-modal__backdrop"
        @click="close"
      />
      <div class="pd-notice-modal__sheet">
        <button
          type="button"
          class="pd-notice-modal__close"
          :aria-label="$t('cancel')"
          @click="close"
        >
          <i class="fal fa-times" />
        </button>
        <div class="pd-notice-modal__scroll">
          <img
            src="/details-before-ordering-mb.png"
            alt=""
          >
        </div>
        <div class="pd-notice-modal__foot">
          <label class="pd-notice-modal__check">
            <input
              v-model="dontShow"
              type="checkbox"
            >
            <span>{{ $t('pdNoticeDontShow') }}</span>
          </label>
          <button
            type="button"
            class="pd-notice-modal__ok"
            @click="close"
          >
            {{ $t('pdNoticeGotIt') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const STORAGE_KEY = 'anan-hide-order-notice'
const MQ = '(max-width: 768px)'

export default {
  name: 'PdNoticeModal',
  props: {
    ready: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      open: false,
      dontShow: false,
      dismissed: false,
    }
  },
  watch: {
    ready() {
      this.scheduleSync()
    },
  },
  mounted() {
    if (this.$el && this.$el.parentNode !== document.body) {
      document.body.appendChild(this.$el)
    }
    this.mq = window.matchMedia(MQ)
    this.onMq = () => this.sync()
    if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq)
    else this.mq.addListener(this.onMq)
    this.scheduleSync()
  },
  beforeDestroy() {
    window.clearTimeout(this.timer)
    if (this.mq) {
      if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq)
      else this.mq.removeListener(this.onMq)
    }
    this.unlock()
    if (this.$el && this.$el.parentNode === document.body) {
      document.body.removeChild(this.$el)
    }
  },
  methods: {
    hiddenByUser() {
      try {
        return window.localStorage.getItem(STORAGE_KEY) === '1'
      } catch (e) {
        return false
      }
    },
    scheduleSync() {
      window.clearTimeout(this.timer)
      this.timer = window.setTimeout(() => this.sync(), 240)
    },
    sync() {
      const shouldOpen = this.ready && this.mq.matches && !this.hiddenByUser() && !this.dismissed
      this.open = shouldOpen
      if (shouldOpen) this.lock()
      else this.unlock()
    },
    lock() {
      document.body.style.overflow = 'hidden'
    },
    unlock() {
      document.body.style.overflow = ''
    },
    close() {
      this.dismissed = true
      if (this.dontShow) {
        try {
          window.localStorage.setItem(STORAGE_KEY, '1')
        } catch (e) { /* ignore quota / private mode */ }
      }
      this.open = false
      this.unlock()
    },
  },
}
</script>
